import React from "react";
import { useMediaQuery } from 'react-responsive';

const Customaifeatures = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "2rem",
      backgroundColor: "#025261",
      color: "#fff",
      flexWrap: "wrap",
    },
    leftSide: {
      flex: 1,
      paddingRight: isMobile ? "0" : "2rem",
      paddingTop: isMobile ? "2rem" : "0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      order: isMobile ? 2 : 1,
    },
    rightSide: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: isMobile ? "0" : "1rem",
      order: isMobile ? 1 : 2,
    },
    header: {
      fontSize: isMobile ? "1.5rem" : "2rem",
      fontWeight: "bold",
      color: "white",
    },
    paragraph: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      margin: "1rem 0",
      textAlign: "justify",
    },
    list: {
      listStyleType: "none",
      paddingLeft: 0,
    },
    listItem: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      marginBottom: "0.5rem",
      display: "flex",
      alignItems: "flex-start",
    },
    arrow: {
      marginRight: "0.5rem",
      color: "#4CAF50",
      fontSize: isMobile ? "1.2rem" : "1.5rem",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: isMobile ? "100%" : "auto",
    },
    image: {
      width: isMobile ? "100%" : "90%",
      maxWidth: "500px",
      height: "auto",
      borderRadius: "8px",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.rightSide}>
        <div style={styles.imageContainer}>
          <img
            src="/image/customai3.png"
            alt="ERP Features"
            style={styles.image}
          />
        </div>
      </div>
      <div style={styles.leftSide}>
        <h2 style={styles.header}>AI Solutions that Drive Innovation and Growth</h2>
        <p style={styles.paragraph}>
         Our custom AI solutions are designed to tackle the challenges unique to your industry.
          We take the time to understand your business processes, identify opportunities for automation and optimization,
           and develop AI models that enhance your decision-making, productivity, and customer experience.
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Tailored AI solutions for specific business challenges
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Scalable and adaptable to future business needs
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Seamless integration with existing systems and processes
          </li>
          {/* <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Scalable Solutions that Grow with Your Business Needs
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Enhanced Collaboration Across Teams and Departments
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default Customaifeatures;